module.exports = __webpack_public_path__ + "img/math__sandbox.3cc75923.svg";